<h-action-button class="find-your-shade" [size]="'medium'" (click)="openModal()" [dataTestId]="'Find-your-shade'">
    <ng-container svgLeft>
        <h-svg-icon class="find-your-shade-icon" [name]="'find-your-shade'"></h-svg-icon>
    </ng-container>
    <ng-container class="find-your-shade-label" i18n="hermes.product-page.launch_button.find_your_shade"
        >Find your shade</ng-container
    >
</h-action-button>
